// extracted by mini-css-extract-plugin
export default {"container":"Tj","header":"Uj","logodesktop":"Vj","logomobile":"Wj","imgcontainer":"Xj","slidercontainer":"Yj","slick-slider":"Zj","slick-initialized":"ak","sliderbox":"bk","headline":"ck","mainheadline":"ek","capitalize":"fk","desc":"gk","descitalic":"hk","desccenter":"ik","descborder":"jk","subdesc":"kk","welcomeslide":"lk","desccard":"mk","img":"nk","button":"ok","buttonskip":"pk","customPosition":"qk"};
    if(module.hot) {
      // 1743628925949
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  